import { BookingState } from "./booking-state"
import { PromocodeModel } from "./promocode.model"
import { TariffModel } from "./tariff.model"

export class BookingModel {
  id!: string
  referenceId!: string
  merchantId!: number
  price!: number
  facilityId!: string // tariffs Model not in webview yet
  licensePlate!: string
  mobileNumber!: string
  refno!: string
  transactionId!: string
  state!: BookingState | null
  deletedAt!: Date | null
  createdAt!: Date | null
  verifiedAt!: Date | null
  startedAt!: Date | null
  stoppedAt!: Date | null
  reservedAt!: Date | null
  paidAt!: Date | null
  requestedReceiptAt!: Date | null
  promocodeId!: string
  verificationCode!: string
  promocode!: PromocodeModel | null
  tariff!: TariffModel | null

  static DEFAULT: BookingModel = {
    id: "",
    referenceId: "",
    merchantId: 0,
    price: 0,
    facilityId: "",
    licensePlate: "",
    mobileNumber: "",
    refno: "",
    transactionId: "",
    state: null,
    deletedAt: null,
    createdAt: null,
    verifiedAt: null,
    startedAt: null,
    stoppedAt: null,
    reservedAt: null,
    requestedReceiptAt: null,
    paidAt: null,
    promocodeId: "",
    verificationCode: "",
    promocode: null,
    tariff: null,
  }
}
